import React from 'react';
import { Branding, IS_FLIPGIVE } from 'common/env';
import { createStyles } from 'utils/createStyle';
import enrollmentStepShop from 'media/images/enrollment-step-shop.png';
import enrollmentStepEarn from 'media/images/enrollment-step-earn.png';
import enrollmentStepFund from 'media/images/enrollment-step-fund.png';

const styles = createStyles({
    section: [
        'w-full pt-10 pb-4 px-6 sm:pt-12 sm:pb-16 sm:px-8',
        {
            background: 'none',
            '@media (min-width: 768px)': {
                background: 'linear-gradient(180deg, #FFFFFF 0%, #E1F1F7 100%)',
            },
        },
    ],
    titleWrapper: 'flex flex-col items-center mb-10',
    title: [
        'text-brand-dark font-bold text-center',
        {
            fontFamily: 'Open Sans, sans-serif',
            fontSize: '28px',
            '@media (min-width: 768px)': { fontSize: '40px' },
        },
    ],
    stepsContainer: [
        'flex flex-col sm:flex-row justify-center mx-auto mb-12',
        { maxWidth: '1170px' },
    ],
    stepItem: [
        'flex flex-col items-start mx-auto',
        {
            width: '100%',
            marginBottom: '44px',
            '@media (min-width: 768px)': { width: '370px', marginBottom: '0', padding: '0 10px' },
        },
    ],
    imageWrapper: [
        'relative w-full mb-2',
        {
            background:
                'linear-gradient(180deg, transparent 0%, rgba(255,255,255,0.3) 30%, white 55%, white 100%)',
            borderRadius: '16px',
            padding: '12px',
        },
    ],
    stepImage: [
        'w-full object-cover',
        {
            height: '165px',
            borderRadius: '10px',
            display: 'block',
            '@media (min-width: 768px)': { height: '225px' },
        },
    ],
    stepNumber: [
        'absolute flex items-center justify-center rounded-full text-white font-bold z-10',
        {
            width: '55px',
            height: '55px',
            fontSize: '22px',
            backgroundColor: '#E6126A',
            top: '-16px',
            left: '35px',
            border: '3px solid white',
        },
    ],
    stepTitle: [
        'text-brand-dark font-bold mb-2',
        {
            fontFamily: 'Open Sans, sans-serif',
            fontSize: '20px',
            '@media (min-width: 768px)': { fontSize: '24px' },
        },
    ],
    stepDescription: [
        'leading-relaxed',
        { fontFamily: 'Open Sans, sans-serif', fontSize: '16px', color: '#424344' },
    ],
});

const steps = [
    {
        number: 1,
        title: 'Shop, dine, and book travel',
        description: `Use ${Branding} to buy gift cards, shop online, dine at ${
            IS_FLIPGIVE ? 'restaurants' : 'local restaurants'
        }, and book travel.`,
        image: enrollmentStepShop,
    },
    {
        number: 2,
        title: 'Earn from every purchase',
        description:
            'Up to 20% of every purchase goes back to your school, team, or group as fundraising dollars.',
        image: enrollmentStepEarn,
    },
    {
        number: 3,
        title: 'Fund what matters most',
        description:
            'Turn everyday spending into something meaningful for your student, athlete, or musician.',
        image: enrollmentStepFund,
    },
];

export const HowRaiseRightWorks = () => {
    return (
        <div className={styles.section}>
            <div className={styles.titleWrapper}>
                <h2 className={styles.title}>How {Branding} works</h2>
            </div>
            <div className={styles.stepsContainer}>
                {steps.map((step) => (
                    <div key={step.number} className={styles.stepItem}>
                        <div className={styles.imageWrapper}>
                            <div className={styles.stepNumber}>{step.number}</div>
                            <img src={step.image} alt={step.title} className={styles.stepImage} />
                        </div>
                        <h3 className={styles.stepTitle}>{step.title}</h3>
                        <p className={styles.stepDescription}>{step.description}</p>
                    </div>
                ))}
            </div>
        </div>
    );
};
